<template>
  <div class="animated fadeIn">
    <template v-if="summaryDataLoaded">

      <!-- Top Row -->
      <!-- <b-row> -->
      <div class="card-deck mb-3">


        <!-- Message Counts -->
        <b-card :no-body="true">
          <b-card-body class="p-3 clearfix">
            <div class="text-muted text-uppercase font-weight-bold font-s">
              Messages Sent
            </div>

            <b-row class="mt-1">
              <b-col sm="4">
                <i class="far fa-comments bg-cyan text-white p-3 font-4xl mr-2 mt-2 float-left"></i>
              </b-col>
              <b-col sm="8" style="margin-left: -10px;">
                <div class="h4 mb-0 mt-2 text-muted">
                  {{ summaryMessagesSent }} Messages
                </div>

                <div id="messagesSentChart" class="d-flex chart-wrapper" style="opacity: 0.75;">
                  <mini-line-chart 
                    :previousValue="summaryMessagesSentPrevious"
                    :currentValue="summaryMessagesSent" 
                    style="height: 60px; width: 90px;"
                  />

                  <!-- Up or down w/ pct -->
                  <span class="align-text-bottom" style="margin-top: 26px;">
                    <template v-if="summaryMessagesSent > summaryMessagesSentPrevious">
                      <i class="far fa-arrow-alt-circle-up text-success font-xl"></i>
                    </template>
                    <template v-else>
                      <i class="far fa-arrow-alt-circle-down text-danger font-base"></i>
                    </template>
                    <span class="text-muted font-small"> {{ formatDelta(summaryMessagesSent, summaryMessagesSentPrevious) }}</span>
                  </span>

                </div>
                <b-tooltip target="messagesSentChart" placement="bottom">
                  <p v-if="summaryMessagesSent > summaryMessagesSentPrevious" style="color: #4dbd74; font-weight: bold;">
                    Up {{ formatDelta(summaryMessagesSent, summaryMessagesSentPrevious) }} from previous {{ selectedTimeFramePhraseNummeric.toLowerCase() }}
                  </p>
                  <p v-else style="color: #f86c6b; font-weight: bold">
                    Down {{ formatDelta(summaryMessagesSent, summaryMessagesSentPrevious) }} from previous {{ selectedTimeFramePhraseNummeric.toLowerCase() }}
                  </p>
                </b-tooltip>
              </b-col>

            </b-row>

          </b-card-body>
        </b-card>


        <!-- Chattiest Hours -->
        <b-card :no-body="true">
          <b-card-body class="p-3 clearfix">
            <div class="text-muted text-uppercase font-weight-bold font-s">
              Chattiest Hours
            </div>

            <b-row class="mt-1">
              <b-col sm="4">
                <i class="far fa-keyboard bg-cyan text-white p-3 font-4xl mr-2 mt-2 float-left"></i>
              </b-col>
              <b-col sm="8">
                <div v-for="hour in summaryChattiestHours" class="h5 mb-0 mt-1 text-muted">
                  {{ hour }}
                </div>

              </b-col>

            </b-row>
            
          </b-card-body>
        </b-card>


        <!-- Latest Sentiment -->
        <b-card :no-body="true">
          <b-card-body class="p-3 clearfix">
            <div class="text-muted text-uppercase font-weight-bold font-s">
              Latest Sentiment
            </div>

            <b-row>
              <b-col sm="3">
                <i :class="summaryLatestSentimentIcon + ' text-white p-3 font-4xl mr-2 mt-3 float-left'"></i>
              </b-col>
              <b-col sm="9">
                <div style="margin-top: -20px; margin-left: -10px; min-height: 90%; max-height: 100%; position: relative;">
                  <template v-if="summarySentimentLatestSorted[0][1] > 0">
                    <gauge-chart 
                        :currentValue="summarySentimentGaugeValue"
                        :centerText="summarySentimentLatestText"
                        :centerTextColor="summarySentimentLatestTextColor"
                        style="max-width: 260px;"
                    />
                  </template>
                  <template v-else>
                    <h5 class="text-muted" style="margin-top: 50px;">{{ summarySentimentLatestText }}</h5>
                  </template>
                </div>
                <!-- 
                <br />
                <div class="h4 mb-0 mt-2" :style="'color: ' + summarySentimentLatestTextColor + ';'">
                  {{ summarySentimentLatestText }}
                </div> -->

              </b-col>

            </b-row>
            
          </b-card-body>
        </b-card>


        <!-- Sentiment Trend -->
        <b-card :no-body="true">
          <b-card-body class="p-3 clearfix">
            <div class="text-muted text-uppercase font-weight-bold font-s">
              Sentiment Trend
            </div>

            <b-row class="mt-1">
              <b-col sm="3">
                <i :class="'far fa-compass ' + summarySentimentTrendIconBg + ' text-white p-3 font-4xl mt-2 float-left'"></i>
              </b-col>
              <b-col sm="9">

                <template v-if="summarySentiment.current_score > summarySentiment.previous_score">
                  <div class="h4 mt-2 text-success">
                    {{ summarySentimentTrendText }}
                  </div>
                  <i class="far fa-arrow-alt-circle-up font-2xl mr-2" style="color: #4dbd74;"></i>
                  <span class="text-muted text-small">
                    from the previous {{ selectedTimeFramePhraseNummeric.toLowerCase() }}
                  </span>
                </template>
                <template v-else-if="summarySentiment.current_score < summarySentiment.previous_score">
                  <div class="h4 mt-2 text-danger">
                    {{ summarySentimentTrendText }}
                  </div>
                  <i class="far fa-arrow-alt-circle-down font-2xl text-danger mr-1"></i>
                  <span class="text-muted">
                    from the previous {{ selectedTimeFramePhraseNummeric.toLowerCase() }}
                  </span>
                </template>
                <template v-else>
                  <!-- They're the same -->
                  <div class="h5 mt-4 text-muted">
                    Not enough data yet
                  </div>
                </template>

              </b-col>

            </b-row>
            
          </b-card-body>
        </b-card>
        
      <!-- </b-row> -->
      </div> 


      <!-- Team Activity Chart -->
      <b-card>
        <b-row class="mb-4">
          <b-col sm="5">
            <h4 id="team-activity" class="card-title mb-0">Workspace Activity</h4>
            <div class="small text-muted">{{ teamActivityStartDay }} - {{ currentDay }}</div>
          </b-col>
          <b-col sm="7" class="d-none d-md-block">
            

          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <team-message-activity-chart 
              v-if="summaryDataLoaded"
              :chart-data="summaryChartData"
              :period="timePeriod"
              id="team-message-activity-chart"
              class="chart-wrapper"
              style="height:360px;"
              height="360" />
          </b-col>
        </b-row>
        
      </b-card>

      <!-- Key Phrases -->
      <div class="card-deck mb-3">
        <b-card :no-body="true">
          <b-card-body class="p-3 clearfix">
            <div class="text-muted text-uppercase font-weight-bold font-s mb-2">
              Key Phrases - All Time
            </div>

            <template v-if="summaryTopGrams.length > 1">
              <grams-table :grams="summaryTopGrams"></grams-table>
            </template>
            <template v-else>
              <p>
                Sorry, we haven't seen enough message data yet to generate key phrases
              </p>
            </template>

          </b-card-body>
        </b-card>

        <b-card :no-body="true">
          <b-card-body class="p-3 clearfix">
            <div class="text-muted text-uppercase font-weight-bold font-s mb-2">
              Key Phrases - Trending
            </div>
            <template v-if="summaryTrendingGrams.length > 1">
              <grams-table :grams="summaryTrendingGrams"></grams-table>    
            </template>
            <template v-else>
              <p>
                Sorry, we haven't seen enough message data in the selected time window to generate key phrases
              </p>
            </template>       

          </b-card-body>
        </b-card>
      </div>


      <!-- Bottom Row -->
      <div class="card-deck mb-3">

        <!-- Top Communicators -->
        <b-card :no-body="true">
          <b-card-body class="p-3 clearfix">
            <div class="text-muted text-uppercase font-weight-bold font-s mb-2">
              Message Leaderboard - Past {{ selectedTimeFramePhraseNummeric }}
            </div>

            <template v-if="summaryTopCommunicators.length > 0">

              <b-table class="mb-0 table-striped" responsive="sm" hover :items="summaryTopCommunicators" :fields="topCommunicatorsFields" head-variant="light">

                <div slot="avatar" class="avatar" slot-scope="item">
                  <img :src="item.value.url" class="img-avatar" alt="">
                  <span class="avatar-status" v-bind:class="{ 'bg-success': item.value.status == 'success',  'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == '' }"></span>
                </div>

                <div slot="teammate" slot-scope="item">
                  <div>
                    <router-link :to="'/details/teammate?uid=' + item.item.slackId" class="unstyled-link">
                      {{item.value}}
                    </router-link>
                  </div>
                </div>

                <div slot="messages" slot-scope="item">
                  <div class="clearfix">
                    <div class="float-left">
                      <strong>{{item.value}}</strong>
                    </div>

                  </div>
                  <b-progress height={} class="progress-xs" v-model="item.value" :max="summaryTopCommunicatorMessages"></b-progress>
                </div>

              </b-table>
            </template>
            <template v-else>
              <p>No messages were received during the selected timeperiod.  Try selecting a longer period.</p>
            </template>

          </b-card-body>

        </b-card>


        <!-- Trending Channels -->
        <b-card :no-body="true">
          <b-card-body class="p-3 clearfix">
            <div class="text-muted text-uppercase font-weight-bold font-s mb-2">
              Trending Channels - Past {{ selectedTimeFramePhraseNummeric }}
            </div>

            <template v-if="summaryTopChannels.length > 0">
              <b-table class="mb-0 table-striped" responsive="sm" hover :items="summaryTopChannels" :fields="topChannelsFields" head-variant="light">

                <div slot="channel" slot-scope="item">
                  <div>
                    <router-link :to="'/details/channel?cid=' + item.item.slackId" class="unstyled-link">
                      #{{item.value}}
                    </router-link>
                  </div>
                </div>

                <div slot="messages" slot-scope="item">
                  <div class="clearfix">
                    <div class="float-left">
                      <strong>{{item.value}}</strong>
                    </div>

                  </div>
                  <b-progress height={} class="progress-xs" v-model="item.value" :max="summaryTopChannelMessages"></b-progress>
                </div>

              </b-table>
            </template>
            <template v-else>
              <p>No messages were received during the selected timeperiod.  Try selecting a longer period.</p>
            </template>
          </b-card-body>

        </b-card>

      </div>

    </template>
    <template v-else>
      <div class="sk-folding-cube align-middle">
        <div class="sk-cube1 sk-cube"></div>
        <div class="sk-cube2 sk-cube"></div>
        <div class="sk-cube4 sk-cube"></div>
        <div class="sk-cube3 sk-cube"></div>
      </div>
    </template>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import TeamActivityChart from './birdseye/TeamActivityChart'  // RIP double Y-axis 
import OnlineUsersChart from './birdseye/OnlineUsersChart'
import TeamMessageActivityChart from './birdseye/TeamMessageActivityChart'
import MiniLineChart from './birdseye/MiniLineChart'
import GaugeChart from './birdseye/GaugeChart'
import GramsTable from './common/GramsTable.vue'
import moment from 'moment'
import { getStyle } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import * as ChartAnnotation from 'chartjs-plugin-annotation'

export default {
  name: 'BirdsEyeViewDashboard',
  components: {
    TeamMessageActivityChart,
    OnlineUsersChart,
    MiniLineChart,
    GramsTable,
    GaugeChart
  },
  data: function () {
    return {
      pageName: 'birdseye',
      currentDay: moment().format('MMMM Do'),

      teamActivityStartDay: moment().subtract(1, 'd').format('MMMM Do'),

      successColor: getStyle('--success'),
      dangerColor: getStyle('--danger'),

      topCommunicatorsFields: {
        avatar: {
          label: '', //'<i class="icon-people"></i>',
          class: 'text-center'
        },
        teammate: {
          label: 'Teammate'
        },
        messages: {
          label: '# Messages'
        }
      },
      topOilBurnersFields: {
        avatar: {
          label: '', //'<i class="icon-people"></i>',
          class: 'text-center'
        },
        teammate: {
          label: 'Teammate'
        },
        hours: {
          label: 'Hours Online'
        }
      },
      topChannelsFields: {
        channel: {
          label: 'Channel'
        },
        messages: {
          label: '# Messages'
        }
      },


    }
    
  },

  watch: {
    timePeriod: function(period, lastPeriod) {
      if(this.$store.getters.currentPage === this.pageName) {
        this.updateBirdsEyeSummary(period)
      }
    }
  },

  computed: {
    teamInfo() {
      return this.$store.getters.teamInfo
    },
    teamMembers() {
      return this.$store.getters.teamMembers
    },
    nonDeletedTeamMembers() {
      return this.$store.getters.nonDeletedTeamMembers
    },
    timePeriod() {
      let p = this.$store.getters.timePeriod
      return p
    },
    selectedTimeFramePhrase() {
      if(this.timePeriod == '6h') {
        return 'The last 6 hours'
      } else if(this.timePeriod == '12h') {
        return 'The last 12 hours'
      } else if(this.timePeriod == 'Day') {
        return 'Yesterday'
      } else if(this.timePeriod == 'Week') {
        return 'Last Week'
      } else if(this.timePeriod == '2Weeks') {
        return 'Last 2 Weeks'
      } else if(this.timePeriod == 'Month') {
        return 'Last Month'
      }
      return 'Unknown timeframe'
    },
    selectedTimeFramePhraseNummeric() {
      if(this.timePeriod == '6h') {
        return '6 Hours'
      } else if(this.timePeriod == '12h') {
        return '12 Hours'
      } else if(this.timePeriod == 'Day') {
        return 'Day'
      } else if(this.timePeriod == 'Week') {
        return 'Week'
      } else if(this.timePeriod == '2Weeks') {
        return 'Two Weeks'
      } else if(this.timePeriod == 'Month') {
        return '30 Days'
      }
      return 'Unknown timeframe'
    },
    summaryDataLoaded() {
      return this.$store.getters.birdseyeSummaryDataLoaded
    },
    summaryData() {
      return this.$store.getters.birdseyeSummaryData
    },
    summaryMessagesSent() {
      let sent = this.$store.getters.birdseyeSummaryData.message_counts[0]
      return sent['channel_messages'] + sent['direct_messages'] + sent['mpim_messages']
    },
    summaryMessagesSentPrevious() {
      let sent = this.$store.getters.birdseyeSummaryData.message_counts[1]
      return sent['channel_messages'] + sent['direct_messages'] + sent['mpim_messages']
    },
    summaryTopGrams() {
      return this.$store.getters.birdseyeSummaryData.top_grams
    },
    summaryTrendingGrams() {
      return this.$store.getters.birdseyeSummaryData.trending_grams
    },
    summarySentiment() {
      return this.$store.getters.birdseyeSummaryData.sentiment
    },
    summarySentimentLatestSorted() {
      let sentiment = this.summarySentiment.latest_sentiment
      let sortedTypes = Object.keys(sentiment).map(function(key) {
        return [key, sentiment[key]];
      }).sort(function(first, second) {
        return second[1] - first[1];
      })
      return sortedTypes
    },
    summarySentimentCurrentScore() {
      // NOT CURRENTLY USED
      // use latest if the current from trend is 0 to avoid regressing to 'not enough data yet' 
      // on low-volume workspaces
      if(this.summarySentiment.current_score == 0 && this.summarySentiment.previous_score == 0 && this.summarySentiment.latest_sentiment.positive > 0) {
        return this.summarySentiment.latest_sentiment.positive
      } else {
        return this.summarySentiment.current_score
      }
    },
    summarySentimentLatestTextColor() {
      let sortedTypes = this.summarySentimentLatestSorted

      if(sortedTypes[0][0] == 'positive') {
        return '#4dbd74'
      } else if(sortedTypes[0][0] == 'negative') {
        return '#f86c6b'
      } else {
        return '#c8ced3'
      }
    },
    summarySentimentGaugeValue() {
      let sentiment = this.summarySentiment.latest_sentiment
      let sortedTypes = this.summarySentimentLatestSorted
      let sType = sortedTypes[0][0]
      let sValue = sortedTypes[0][1] * 10000  // gauge operates 0-10k
      sValue = sValue - (Math.random() * (650 - 420) + 420)  // just to avoid max-looking situations
      // sValue = 3308
      // console.log(sValue)

      // negative must be between 0 and 3500
      // neutral/mixed must be between 3501 and 6500
      // positive must be between 6501 and 10000

      let sValueMin = 2650  // 4 categories, 2500 is the minimum the top sent value could have
      let sValueMax = 10000
      let min = 0
      let max = 0

      sValue = Math.max(sValue, sValueMin) // handle cases of no score

      if(sType == 'negative') {
        min = 0
        max = 3500
      } else if(sType == 'positive') {
        min = 6501
        max = 10000
      } else {
        // neutral/mixed
        min = 3501
        max = 6500
      }

      let percent = (sValue - sValueMin) / (sValueMax - sValueMin)
      let gaugeValue = percent * (max - min) + min

      if(sType == 'negative') {
        // gotta flip negative because high neg should be lower on gauge
        gaugeValue = max - gaugeValue
      }
      // console.log('Gauge value: ' + gaugeValue.toString())
      return gaugeValue
    },
    summarySentimentLatestText() {
      let sortedTypes = this.summarySentimentLatestSorted

      if(sortedTypes[0][1] == 0 && sortedTypes[1][1] == 0 && sortedTypes[2][1] == 0 && sortedTypes[3][1] == 0) {
        // no sentiment data!  return appropriate value
        return 'Not enough data yet'
      }

      let str = ''
      // not using this logic for now since switching to gauge view
      if(sortedTypes[0][0] == 'positive' || sortedTypes[0][0] == 'negative') {
        if(sortedTypes[0][1] > 0.80) {
          // str += 'Very '
        } else {
          // str += 'Moderately '
        }
      }

      let upper = sortedTypes[0][0].charAt(0).toUpperCase() + sortedTypes[0][0].slice(1)
      str += upper
      return str
    },
    summaryLatestSentimentIcon() {
      let sortedTypes = this.summarySentimentLatestSorted

      if(sortedTypes[0][1] == 0 && sortedTypes[1][1] == 0 && sortedTypes[2][1] == 0 && sortedTypes[3][1] == 0) {
        // no sentiment data!  return appropriate value
        return 'far fa-question-circle bg-secondary'
      }

      let classStr = ''
      if(sortedTypes[0][0] == 'positive') {
        if(sortedTypes[0][1] >= 0.80) {
          // very positive
          return 'far fa-smile-beam bg-success'
        } else {
          // normal positive
          return 'far fa-smile bg-success'
        }
      } else if(sortedTypes[0][0] == 'negative') {
        if(sortedTypes[0][1] >= 0.80) {
          return 'far fa-frown-open bg-danger'
        } else {
          return 'far fa-frown bg-danger'
        }
      } else {
        return 'far fa-meh bg-secondary'
      }       
    },
    summarySentimentTrendText() {
      let apiPhrase = this.summarySentiment.phrase
      let text = apiPhrase
      
      // bree thinks the adverb is not valuable, strip it out.  i want to retain it in the API response
      if(text.includes(' ')) {
        let pos = text.indexOf(' ')
        text = text.substring(pos+1)
      }
      return text
    },
    summarySentimentTrendIconBg() {
      if(this.summarySentiment.current_score > this.summarySentiment.previous_score) {
        return 'bg-success'
      } else if(this.summarySentiment.current_score < this.summarySentiment.previous_score) {
        return 'bg-danger'
      } else {
        return 'bg-secondary'
      }
    },
    summaryChartData() {
      return this.$store.getters.birdseyeSummaryData.summary_chart_data
    },
    summaryTopCommunicatorMessages() {
      let c = this.$store.getters.birdseyeSummaryData.communicators[0]
      if(c.length > 0) {
        return c[0].total_messages
      }
      return 100
    },

    summaryTopChannelMessages() {
      let c = this.$store.getters.birdseyeSummaryData.channels[0]
      if(c.length > 0) {
        return c[0].total_messages
      }
      return 100
    },
    summaryTopCommunicators() {
      // for now just showing 1 period, not a delta, so return 0th element
      let communicators = this.$store.getters.birdseyeSummaryData.communicators[0]
      // let onlineUsers = this.$store.getters.birdseyeSummaryData.online_users
      let formattedCommunicators = []
      for (const communicator of communicators) {
        let user = this.$store.getters.teamMember(communicator.user_id)
        let status = ''
        // if(onlineUsers.includes(communicator.user_id)) {
        //   status = 'success'
        // }
        // console.log(user)
        formattedCommunicators.push({
          avatar: {url: user.avatar, status: status},
          teammate: user.real_name,
          slackId: user.slack_id,
          messages: communicator.total_messages
        })
      }
      return formattedCommunicators
    },
    summaryTopChannels() {
      // for now just showing 1 period, not a delta, so return 0th element
      let channels = this.$store.getters.birdseyeSummaryData.channels[0]
      let formattedChannels = []
      for (const channel of channels) {
        let teamChannel = this.$store.getters.teamChannel(channel.channel_id)

        // console.log(teamChannel)
        formattedChannels.push({
          channel: teamChannel.name,
          slackId: teamChannel.slack_id,
          messages: channel.total_messages
        })
      }
      return formattedChannels
    },
    summaryChattiestHours() {
      let d = this.summaryChartData
      let sortedHours = Object.keys(d).sort(function(a, b) { 
        return d[b].total_messages - d[a].total_messages
      })
      // console.log(d[sortedHours[0]].total_messages)
      if(d[sortedHours[0]].total_messages == 0) {
        return ['Not enough data']
      }
      // sortedHours = sortedHours.slice(0, 3)  //top 3

      let uniqueSortedHours = []
      while(uniqueSortedHours.length < 3) {

        if(sortedHours.length == 0) {
          break
        }
        // get first element
        let ep = sortedHours.shift()
        
        // if the hour epoch is the same 0-24h but on another day, don't include it
        let dupeHour = false
        for(let i = 0; i < uniqueSortedHours.length; i++) {
          if((ep - uniqueSortedHours[i]) % 86400 == 0) {
            dupeHour = true
            // console.log('dupe hour!')
          }
        }
        if(!dupeHour) {
          uniqueSortedHours.push(ep)
        }
      }
      
      // now iterate from the end to the start removing 0 count hours
      for(let i = uniqueSortedHours.length -1; i >= 0; i--) {
        if(d[uniqueSortedHours[i]].total_messages == 0) {
          uniqueSortedHours.splice(i, 1);
        }
      }

      // now sort by hour in the day starting at 12AM
      let dayAscendingHours = uniqueSortedHours.sort((a, b) => (parseInt(moment.unix(a).format('H')) > parseInt(moment.unix(b).format('H'))) ? 1 : -1)

      let formattedHours = dayAscendingHours.map(
        epoch => moment.unix(epoch).format('hA') 
          + ' - ' 
          + moment.unix(epoch).add(1, 'h').format('hA')
      )
      console.log(formattedHours)
      return formattedHours
    }
  },
  
  methods: {
    formatDelta: function(current, previous) {
      if(current == 0 && previous == 0) {
        return '0%'
      }

      let delta = Math.round((current - previous) / previous * 100)
      if(!isFinite(delta)) {
        return 'Greatly'
      } else {
        if(delta >= 500 || delta <= -500) {
          return 'Greatly'
        } else {
          return delta.toString() + '%'
        }
      }
    },
    updateBirdsEyeSummary: function(period) {
      this.$store.dispatch('updateBirdsEyeSummary', period)

      if(period == '6h') {
        this.teamActivityStartDay = moment().subtract(6, 'h').format('MMMM Do')
      } else if(period == '12h') {
        this.teamActivityStartDay = moment().subtract(12, 'h').format('MMMM Do')
      } else if(period == 'Day') {
        this.teamActivityStartDay = moment().subtract(1, 'd').format('MMMM Do')
      } else if(period == 'Week') {
        this.teamActivityStartDay = moment().subtract(7, 'd').format('MMMM Do')
      } else if(period == '2Weeks') {
        this.teamActivityStartDay = moment().subtract(14, 'd').format('MMMM Do')
      } else if(period == 'Month') {
        this.teamActivityStartDay = moment().subtract(30, 'd').format('MMMM Do')
      }
    }
  },

  mounted() {
    this.$store.commit('currentPage', this.pageName)
    this.updateBirdsEyeSummary(this.timePeriod)
  },

  created() {
    // this.$store.subscribe((mutation, state) => {
    //   if (mutation.type === 'timePeriod') {
    //     if(this.$store.getters.currentPage === this.pageName) {
    //       this.updateBirdsEyeSummary(this.$store.getters.timePeriod)
    //     }
    //   }
    // });
  },


}
</script>
